import styles from './FJImageUpload.module.less';

import FJLocalStore from '../../../../store/FJLocalStore';
import { UPLOAD_FILE_TYPE_NO_GIF } from '../../../../config/dataConfig/FJGenerateData';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useRef, useState } from 'react';
import FJPreviewBox from '../../FJPreviewBox/FJPreviewBox';
import UploadBorderHoverIcon from '../../../../assets/svg/upload-border-hover.svg?react';
import UploadBorderIcon from '../../../../assets/svg/upload-border.svg?react';
import ReUploadIcon from '../../../../assets/svg/re-upload.svg?react';
import FJCancelIcon from '../../../../assets/svg/aiGeneratorVideo/cancel.svg?react';

const FJImageUpload = props => {
    const {
        imageInfo = {},
        uploadImg,
        defaultIcon,
        uploadText = 'upload-image',
        smallIcon,
        className,
        uploadTextClassName,
        openMediaLibrary,
        style,
        acceptFile,
        onDelete,
        label,
        previewClassName,
        leftBottomIcon,
        previewImageStyle,
        uploadTitle,
    } = props;
    const { src: imgSrc } = imageInfo;
    const inputRef = useRef(null);
    const [isDraggingFile, setIsDraggingFile] = useState(false);
    const _onUploadImg = e => {
        const file = e.target.files[0];
        uploadImg(file);
        e.target.value = null;
    };

    const _onClick = () => {
        if (window.isEditPage && openMediaLibrary) {
            openMediaLibrary();
        } else if (inputRef.current) {
            inputRef.current.click();
        }
    };
    const _onDragOver = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(true);
    };

    const _onDragLeave = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
    };

    const _onDragDrop = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
        let files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            uploadImg(file);
        }
    };

    const _onDelete = e => {
        e.stopPropagation();
        e.preventDefault();
        onDelete();
    };

    return (
        <div
            className={classNames(styles.box, imgSrc ? styles.has_img : '', className)}
            onClick={_onClick}
            onDragOver={_onDragOver}
            onDrop={_onDragDrop}
            onDragLeave={_onDragLeave}
            style={style}
        >
            {imgSrc ? (
                <>
                    <img className={styles.preview_img} src={imgSrc} alt='' loading='lazy' />
                    <div className={classNames(styles.blur_mask, isDraggingFile ? styles.dragging : '')}>
                        {isDraggingFile && <ReUploadIcon />}
                        <span className={styles.reupload_text}>
                            {isDraggingFile ? FJLocalStore._('replace') : FJLocalStore._('change-image')}
                        </span>
                    </div>
                    {label && <div className={styles.label}>{label}</div>}
                    <div className={styles.small_icon}>{smallIcon}</div>
                    <div className={styles.delete_icon} onClick={_onDelete}>
                        <FJCancelIcon />
                    </div>
                    {leftBottomIcon && <div className={styles.left_bottom_icon}>{leftBottomIcon}</div>}
                </>
            ) : (
                <div className={classNames(styles.blank_box, isDraggingFile ? styles.dragging : '')}>
                    {defaultIcon}
                    {uploadTitle && (
                        <span className={classNames(styles.upload_title)}>{FJLocalStore._(uploadTitle)}</span>
                    )}
                    <span className={classNames(styles.blank_text, uploadTextClassName)}>
                        {FJLocalStore._(uploadText)}
                    </span>
                    <UploadBorderHoverIcon className={styles.upload_border_hover} />
                    <UploadBorderIcon className={styles.upload_border} />
                </div>
            )}

            <input
                type='file'
                ref={inputRef}
                className={styles.file_input}
                accept={acceptFile || UPLOAD_FILE_TYPE_NO_GIF}
                onChange={_onUploadImg}
            />

            <div className={styles.dragging_mask}></div>
            <FJPreviewBox
                imageInfo={imageInfo}
                previewClassName={classNames(previewClassName || styles.preview_box)}
                style={previewImageStyle}
            />
        </div>
    );
};
FJImageUpload.propTypes = {
    imageInfo: PropTypes.object,
    uploadImg: PropTypes.func,
    defaultIcon: PropTypes.node,
    uploadText: PropTypes.string,
    smallIcon: PropTypes.node,
    className: PropTypes.string,
    uploadTextClassName: PropTypes.string,
    openMediaLibrary: PropTypes.func,
    onDelete: PropTypes.func,
    previewClassName: PropTypes.string,
};

export default FJImageUpload;
